<mat-form-field [formlyAttributes]="field">
  <mat-label>
    {{ props.label }}
    <span [hidden]="!props?.required" class="mat-form-field-required-marker">*</span>
  </mat-label>
  <mat-chip-grid #chipGrid aria-label="Enter items" [formControl]="formControl">
    @for (item of items(); track item) {
      <mat-chip-row
        (removed)="removeItem(item)"
        [class.chip-invalid]="isInvalidItem(item, props['invalidItemValidator'])"
      >
        {{ item }}
        <button matChipRemove [attr.aria-label]="'remove ' + item">
          <mat-icon class="material-symbols-outlined">cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>
  <input
    placeholder="New item..."
    [matChipInputFor]="chipGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
    (matChipInputTokenEnd)="addItem(chipInput)"
    (blur)="addItem(chipInput)"
    [formlyAttributes]="field"
    #chipInput
  />
  @if (showError) {
    <mat-error aria-atomic="true" aria-live="polite">
      <formly-validation-message [field]="field"></formly-validation-message>
      @if (formControl.errors?.['resource-url']?.length) {
        <ul class="chip-error-list">
          @for (url of formControl.errors?.['resource-url']; track url) {
            <li>{{ url }}</li>
          }
        </ul>
      }
    </mat-error>
  }
</mat-form-field>
